import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import InputControl from '../buttons/input-control'

class InputAmount extends React.Component {
  render() {
    const {
      theme,
      id,
      defaultValue,
      value,
      onSubmit,
      onChange,
      onFocus,
      onBlur,
      disabled,
      onClickLeft,
      onClickRight,
      leftControlDisabled
    } = this.props
    return (
      <div
        className={classNames({
          'form-field': true,
          'amount-field': true,
          [theme]: true
        })}
      >
        <InputControl
          disabled={leftControlDisabled}
          iconName='minus'
          onClick={onClickLeft}
        />
        <div>
          <input
            type='text'
            autoComplete='off'
            className='form-input'
            id={id}
            defaultValue={defaultValue}
            value={value}
            onSubmit={onSubmit}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            disabled={disabled ? 'disabled' : ''}
          />
        </div>
        <InputControl
          iconName='plus'
          className='pull-right'
          onClick={onClickRight}
        />
      </div>
    )
  }
}

InputAmount.propTypes = {
  onClickLeft: PropTypes.func.isRequired,
  onClickRight: PropTypes.func.isRequired,
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  hasText: PropTypes.bool,
  disabled: PropTypes.bool,
  theme: PropTypes.oneOf(['light-theme', 'dark-theme']),
  leftControlDisabled: PropTypes.bool
}

export default InputAmount



// WEBPACK FOOTER //
// ./src/ui/forms/input-amount.js